import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from './AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const WishlistContext = createContext();

export function WishlistProvider({ children }) {
  const { user } = useAuth();
  const [wishlistIds, setWishlistIds] = useState([]);

  const fetchWishlist = useCallback(async () => {
    if (!user) { setWishlistIds([]); return; }
    try {
      const res = await axios.get(`${API}/wishlist`, { withCredentials: true });
      setWishlistIds(res.data.product_ids || []);
    } catch {
      setWishlistIds([]);
    }
  }, [user]);

  useEffect(() => { fetchWishlist(); }, [fetchWishlist]);

  const toggleWishlist = useCallback(async (productId) => {
    if (!user) return false;
    const isInWishlist = wishlistIds.includes(productId);
    try {
      if (isInWishlist) {
        await axios.delete(`${API}/wishlist/${productId}`, { withCredentials: true });
        setWishlistIds(prev => prev.filter(id => id !== productId));
      } else {
        await axios.post(`${API}/wishlist/${productId}`, {}, { withCredentials: true });
        setWishlistIds(prev => [...prev, productId]);
      }
      return !isInWishlist;
    } catch {
      return isInWishlist;
    }
  }, [user, wishlistIds]);

  const isWishlisted = useCallback((productId) => {
    return wishlistIds.includes(productId);
  }, [wishlistIds]);

  return (
    <WishlistContext.Provider value={{ wishlistIds, fetchWishlist, toggleWishlist, isWishlisted }}>
      {children}
    </WishlistContext.Provider>
  );
}

export const useWishlist = () => useContext(WishlistContext);
